import { UPDATE_THEME, UPDATE_USER, UPDATE_NOTIFICATION } from "./actionTypes";

export const updateTheme = (content) => ({
  type: UPDATE_THEME,
  payload: content,
});
export const updateUser = (content) => ({
  type: UPDATE_USER,
  payload: content,
});
export const updateNotification = (content) => ({
  type: UPDATE_NOTIFICATION,
  payload: content,
});
